import * as Icons from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { OvernightReportCard } from "@/components/AdminReports";

export default function OvernightReport() {
  const { isAdmin } = useAuth();
  if (!isAdmin) return <div className="max-w-md mx-auto mt-16 text-center" data-testid="restricted-notice"><Icons.Lock className="h-8 w-8 mx-auto text-destructive mb-3" /><h2 className="font-display text-xl font-bold">Admins only</h2></div>;
  return (
    <div className="space-y-6" data-testid="overnight-report-page">
      <div>
        <h1 className="font-display text-2xl font-bold tracking-tight">Overnight Auto-Exit Report</h1>
        <p className="text-sm text-muted-foreground">Entries closed by the 12:05 AM IST auto-exit and vehicles still waiting for an admin exit</p>
      </div>
      <OvernightReportCard />
    </div>
  );
}
